export const INCLUDE = 'include';
export const EXCLUDE = 'exclude';

export const AVAILABLE_FIELDS_LIST = 'Available Fields';
export const SELECTED_FIELDS_LIST = 'Selected Fields';
export const PRESET_FIELDS_LIST = 'Preset Fields';

export const TRINO_API_TYPE = 'Trino';
export const SNOWFLAKE_API_TYPE = 'Snowflake';

export const DEFAULT_LOG_TYPE = 'Events';
export const POSTBACKS_LOG_TYPE = 'Postbacks';
export const INSTALLS_LOG_TYPE = 'Installs';
export const FPS_LOG_TYPE = 'Fps';
export const SKAN_POSTBACK_LOG_TYPE = 'Skan_postback';

export const EXPORT_TYPE_MAPPING = {
    Events: 'event',
    Postbacks: 'postback',
    Fps: 'fps',
    Clicks: 'click',
    Historical_import: 'historical_import',
    Rejected_installs: 'rejected_installs',
    Assist: 'assist',
    Installs: 'attribution',
    Users: 'user_attribution',
    Skan_postback: 'skan_postback',
    App_skan_postback: 'app_skan_postback',
};

export const CONVERSION_TYPES = ['ALL', 'INSTALL', 'REENGAGEMENT'];

export const REVENUE_EVENT_FILTERS = {
    IAP: '__ALL_IAP_REVENUE_EVENTS__',
    ADMON: '__ADMON_USER_LEVEL_REVENUE__',
};

export const BASIC_DEVICE_ID_TYPES = [
    'device_id',
    'gaid',
    'gaid_md5',
    'gaid_sha1',
    'idfa',
    'idfa_md5',
    'idfa_sha1',
    'idfv',
    'sing',
    'oaid',
    'amid',
    'sdid',
];

export const FPS_DEVICE_ID_TYPES = ['device_id', 'idfv'];

export const BASIC_POSTBACK_TYPES_BLOCKLIST = ['TW_INSTALL', 'FB_INSTALL', 'CONNECTOR PING', 'CROSS-NETWORK PING'];

export const EXPORT_LOGS_EMPTY_STATE_TASKS = [
    {
        topic: 'sdk_integrated',
        name: 'STATIC.EMPTY_STATE.TASKS.SDK_TASK',
        goRedirect: '#/react/sdk_integration',
    },
    {
        topic: 'export_event_level_data',
        name: 'STATIC.EMPTY_STATE.TASKS.EXPORT_EVENT_LEVEL_TASK',
        goRedirect: '',
        disabled: true,
    },
];
